<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="abbreviation" slot-scope="abbreviation">
          <div class="font-weight-bold">{{abbreviation}}</div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- <a href="javascript:;" class="btn btn-sm btn-light mr-2" @click="showEditModal(record)">
              <edit-subject ref="editSubject" @edited="handleEdited"/>
            </a> -->
            <!-- Edit -->
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-subject ref="editSubject" @edited="handleEdited"/> -->
              Edit
            </a>
            <a-tooltip placement="top">
              <template slot="title" v-if="record.class_subjects_count !== 0">
                <span>Cannot Delete. Related data present under this record!</span>
              </template>
              <span>
                <!-- Delete -->
                <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon"
                  @click="onDelete(record)" :class="record.class_subjects_count !== 0 ? 'disabled' : ''"
                >
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </span>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <edit-subject ref="editSubject" @edited="handleEdited"/>
  </div>
</template>
<script>
import EditSubject from '@/components/subject/Forms/Edit/index'

const columns = [
  {
    title: 'Subjects',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Abbreviation',
    dataIndex: 'abbreviation',
    scopedSlots: { customRender: 'abbreviation' },
    sorter: (a, b) => a.abbreviation.localeCompare(b.abbreviation),
  },
  {
    title: 'Descriptions',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' },
    sorter: (a, b) => a.description.localeCompare(b.description),
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'SubjectsTable',
  components: {
    EditSubject,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editSubject.showModal(record.id)
      this.$eventBus.$emit('openSubjectEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this board?',
        content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/subject/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
